import { BIGQUERY_GROUP } from '../../constants';

/**
 * Type name of the BigQuery event.
 * @type {String}
 */
export const BIGQUERY_TYPE_ACKNOWLEDGED = 'clicked_header.chat_tooltip_ack';
export const BIGQUERY_TYPE_IMPRESSION = 'clicked_header.chat_tooltip_impression';

/**
 * BigQuery event to send on click.
 * @type {Object}
 */
export const BIGQUERY_EVENT_ACKNOWLEDGED = {
    type: BIGQUERY_TYPE_ACKNOWLEDGED,
    group: BIGQUERY_GROUP,
};

export const BIGQUERY_EVENT_IMPRESSION = {
    type: BIGQUERY_TYPE_IMPRESSION,
    group: BIGQUERY_GROUP,
};

export const MIXPANEL_EVENT_ACKNOWLEDGED = {
    eventName: 'Chat tooltip acknowledged',
    eventData: { 'Source Component': 'Header' },
};

export const MIXPANEL_EVENT_IMPRESSION = {
    eventName: 'Chat tooltip impression',
    eventData: { 'Source Component': 'Header' },
};
